export default function TimeInputGroup({
    names = [],
    values = ["00", "00", "00"],
    readOnly = [],
    onChange,
}) {
    return (
        <div className="config-time-inputs">
            {names.map((name, index) => (
                <div key={name} className="config-time-inputs__part">
                    {index > 0 ? <span className="config-time-inputs__sep">:</span> : null}
                    <input
                        name={name}
                        readOnly={readOnly.includes(index)}
                        className="form-control form-control-sm text-center"
                        type="number"
                        min="0"
                        value={values[index] ?? "00"}
                        onChange={(e) => onChange?.(name, e.target.value)}
                    />
                </div>
            ))}
        </div>
    );
}
